import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mcommerce-trip-detail-cart-cancel-purchase-dialog',
  templateUrl: './mcommerce-trip-detail-cart-cancel-purchase-dialog.component.html',
  styleUrls: ['./mcommerce-trip-detail-cart-cancel-purchase-dialog.component.scss']
})
export class McommerceTripDetailCartCancelPurchaseDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<McommerceTripDetailCartCancelPurchaseDialogComponent>) { }

  ngOnInit() {
  }

}
